module.exports = {
      id: "close-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "images/js_src_vue/page_adguard_landing/sprite.dab809d9.svg#close-usage",
      toString: function () {
        return this.url;
      }
    }